/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  // CardActions,
  CardHeader,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  // TableFooter,
  Paper
} from '@mui/material';
import PropTypes from 'prop-types';
import { Close } from '@mui/icons-material';

const InvoiceTable = ({ currencyData, currency }) => {
  return (
    <>
      <Typography component="p" variant="body1" sx={{ mt: 2 }}>
        Currency : <b>{currency}</b>
      </Typography>
      <TableContainer component={Paper} elevation={1} sx={{ mt: 2 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Invoice Number</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Invoice Date</TableCell>
              <TableCell>Amount</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {currencyData &&
              currencyData?.invoices.map((invoice, index) => (
                <TableRow key={index}>
                  <TableCell>{invoice.invoice_number}</TableCell>
                  <TableCell>{invoice.primary_email}</TableCell>
                  <TableCell>{invoice.invoice_date}</TableCell>
                  <TableCell>{`${invoice.short_name} ${invoice.grand_total}`}</TableCell>
                </TableRow>
              ))}
            <TableRow>
              <TableCell colSpan={2} />
              <TableCell sx={{ color: '#000', fontSize: '16px' }} align="center">
                Total
              </TableCell>
              <TableCell sx={{ color: '#000', fontSize: '16px' }}>
                <b>{`${currencyData?.Currency} ${currencyData?.Total}`}</b>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

InvoiceTable.propTypes = {
  currencyData: PropTypes.string.isRequired,
  // total: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired
};

function PendingPaymentRequest({ data, openmodal, onCloseModal }) {
  return (
    <Dialog
      fullWidth
      maxWidth="md"
      className="cmn__delete__modal"
      open={openmodal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <DialogTitle id="scroll-dialog-title" sx={{ bgcolor: '#f7f8f3' }}>
        <CardHeader
          sx={{ p: '0 !important' }}
          title="Pending Invoices"
          action={
            <IconButton
              aria-label="settings"
              onClick={() => {
                onCloseModal();
              }}
            >
              <Close />
            </IconButton>
          }
        />
      </DialogTitle>
      <DialogContent
        className="dataTable__wrap"
        sx={{ maxWidth: '100% !important', p: '20px !important' }}
      >
        {Object.keys(data).map((currencyKey) => (
          <InvoiceTable
            key={currencyKey}
            currency={data[currencyKey].Currency}
            currencyData={data[currencyKey]}
          />
        ))}
      </DialogContent>
    </Dialog>
  );
}
PendingPaymentRequest.propTypes = {
  data: PropTypes.string.isRequired,
  // total: PropTypes.string.isRequired,
  // currency: PropTypes.string.isRequired,
  openmodal: PropTypes.string.isRequired,
  onCloseModal: PropTypes.func.isRequired
};

export default PendingPaymentRequest;
